import { BedarfPrioritaet, BedarfPrioritaetConfig } from '../../types/bedarf';

interface BedarfPriorityBadgeProps {
  priority: BedarfPrioritaet;
  size?: 'sm' | 'md';
}

export function BedarfPriorityBadge({ priority, size = 'md' }: BedarfPriorityBadgeProps) {
  const config = BedarfPrioritaetConfig[priority] || { label: priority, color: 'text-gray-600', bgColor: 'bg-gray-100' };

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-0.5 text-sm';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${config.bgColor} ${config.color} ${sizeClasses}`}
    >
      {config.label}
    </span>
  );
}
